import type { SelectOption } from '~/shared/utils/types';

import type { ExplorationVolume } from '../../types/exploration';
import { buildTagOptions } from '../../lib/filters/buildCheckboxFilterOptions';
import FilterCheckboxList from './FilterCheckboxList';

export default function VolumeTagsFilter({
  volumes,
  pendingTagFilters,
  setPendingTagFilters,
  globalSearchQuery = '',
  isDisclosureOpen = false,
}: {
  volumes: ExplorationVolume[];
  pendingTagFilters: SelectOption[];
  setPendingTagFilters: (filters: SelectOption[]) => void;
  globalSearchQuery?: string;
  isDisclosureOpen?: boolean;
}) {
  const tagOptions = buildTagOptions(volumes);
  const options = tagOptions.map((option) => ({
    key: `${option.tagKey}:${option.key}`,
    label: option.label,
    count: option.count,
  }));

  const handleChange = (id: string) => {
    const selected = pendingTagFilters.some((f) => f.id === id);
    if (selected) {
      setPendingTagFilters(pendingTagFilters.filter((f) => f.id !== id));
    } else {
      const colonIdx = id.indexOf(':');
      const tagKey = colonIdx >= 0 ? id.slice(0, colonIdx) : id;
      setPendingTagFilters([
        ...pendingTagFilters,
        { id, name: id, group: `tag:${tagKey}` as SelectOption['group'] },
      ]);
    }
  };

  if (!options.length) return null;

  return (
    <FilterCheckboxList
      options={options}
      globalSearchQuery={globalSearchQuery}
      showSectionSearch
      isDisclosureOpen={isDisclosureOpen}
      isSelected={(key) => pendingTagFilters.some((f) => f.id === key)}
      onToggle={handleChange}
      tagVariant="volume"
    />
  );
}

export function buildVolumeTagFilterOptions(volumes: ExplorationVolume[]) {
  return buildTagOptions(volumes).map((option) => ({
    key: `${option.tagKey}:${option.key}`,
    label: option.label,
    count: option.count,
  }));
}
